import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants/queryKeys';
import { callPublicAPI } from '../utils/api';
import { UserNotification } from '../types/types';

export const useRemindersList = (enabled = true) => {
  return useQuery<string[]>({
    queryKey: [QUERY_KEYS.GET_OFFERS, QUERY_KEYS.GET_OFFERS_VARIATION.COMING_SOON_NOTIFICATIONS],
    queryFn: async () => {
      const offersWithReminder = await callPublicAPI<UserNotification[]>('GET', '/user-notifications');
      if (offersWithReminder.data && offersWithReminder.data.length > 0) {
        return offersWithReminder.data.map(reminder => reminder.adId);
      }

      return [];
    },
    enabled
  });
};
